export default "__VITE_ASSET__b2351113__"